module.exports = __webpack_public_path__ + "static/img/hd_bg.0d2a0a51.png";